import {createSelector} from 'reselect';
import {calculateAndFormatUnixDates} from '../../../utils/date-utils';
import {getUserFunds} from '../UserFunds/userFunds.selectors';
import {currency} from '../../../utils/dashboard-utils';

export const getRecentTransactionsData = (state) => {
  return state.RecentTransactions.data;
};

const OWNR_ROLE_CODE = 'OWNR',
  PRIMARY_PARTY_CODE = 'Y';

export const formatAccountOwners = (parties) => {
  const owners = parties.filter(({ roleCode }) => roleCode === OWNR_ROLE_CODE);
  const primary = owners.filter(
    ({ primaryParty }) => primaryParty === PRIMARY_PARTY_CODE
  );
  const others = owners.filter(
    ({ primaryParty }) => primaryParty !== PRIMARY_PARTY_CODE
  );

  return [...primary, ...others].map(({ fullName }) => fullName);
};

const getAcct = (funds, agreementID) =>
  [
    funds.retirementAgreements,
    funds.nonRetirementAgreements,
    funds.collegeSavingsAgreements,
  ]
    .filter(Boolean)
    .flatMap((agmts) => Object.values(agmts))
    .flat()
    .find((agmt) => agmt.agreementID === agreementID);

export const getRecentTransactionList = createSelector(
  getRecentTransactionsData,
  getUserFunds,
  (transactions, userFunds) =>
    transactions
      .map((t) => [t, getAcct(userFunds, t.accountID)])
      // remove any transactions don't come back in the display/info call
      .filter(([, acct]) => Boolean(acct))
      .map(([transaction, acct]) => {
        const {
          accountID,
          date,
          detail: unformattedDetail,
          amount,
          quantity,
          price,
          costBasis,
        } = transaction;

        const {
          agreementType,
          agreementNumber,
          agreementParties,
          fundName,
          ticker,
        } = acct;

        const detail = (
          <>
            {unformattedDetail}
            {costBasis && <div>Cost Basis Method: {costBasis}</div>}
          </>
        );

        const accountType = agreementType?.replace(/_/, ' ');

        return {
          displayDate: calculateAndFormatUnixDates(date),
          detail,
          accountID,
          accountInfo: {
            ticker,
            accountType,
            fundName,
            agreementNumber,
            owners: formatAccountOwners(agreementParties),
          },
          qty: quantity,
          price: currency(price),
          amt: currency(amount),
        };
      })
);
